import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useSubscription } from "@/context/SubscriptionContext";
import { useI18n } from "@/context/I18nContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { tokenStorage } from "@/lib/tokenStorage";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { t } = useI18n();
  const nav = useNavigate();
  const loc = useLocation();
  const { refreshUser } = useAuth();
  const { refresh: refreshSub } = useSubscription();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = loc.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const sid = decodeURIComponent(m[1]);
    // Clean the URL fragment
    window.history.replaceState({}, "", loc.pathname);

    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id: sid });
        tokenStorage.set("uc_token", r.data.access_token);
        await refreshUser();
        // Check subscription and route accordingly
        try {
          const s = await api.get("/billing/subscription");
          await refreshSub();
          nav(s.data?.has_active ? "/dashboard" : "/pricing", { replace: true });
        } catch {
          nav("/pricing", { replace: true });
        }
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Google girişi başarısız");
        nav("/login", { replace: true });
      }
    })();
  }, [loc, nav, refreshUser, refreshSub]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{background:"var(--bg)"}} data-testid="auth-callback">
      <div className="text-center">
        <Loader2 size={40} className="mx-auto animate-spin" style={{color:"var(--gold)"}} />
        <div className="font-display text-2xl mt-6" style={{color:"var(--gold)"}}>MİLYEMSOFT</div>
        <div className="text-sm text-neutral-400 mt-2">{t("auth.connecting")}</div>
      </div>
    </div>
  );
}
